import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ITableServerFilter } from 'src/app/common/interfaces/table/table-server-filter.inteface';
import { ITableServerResponseFilter } from 'src/app/common/interfaces/table/table-server-filter-response.interface';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { IReturnInitiate } from '../../interfaces/return-list/return-initiate.interface';
import { IRtpInitiatedReturnList } from '../../interfaces/initiated-return/rtp-initiated-return-list.interface';
import { IRtpInitiatedReturnDetails } from '../../interfaces/initiated-return/rtp-initiated-return-detail.interface';
import { AbstractRtpReturnInitiatedService } from '../abstraction/abstract.rtp-return-initiated.service';

@Injectable({
  providedIn: 'root',
})
export class RtpReturnInitiatedService extends AbstractRtpReturnInitiatedService {
  private controller = `/manager/rtp/returnrequestsend`;
  private urlGetReturnList = `${environment.apiUrl}${this.controller}/grid`;
  private urlGetReturnListExportCSV = `${environment.apiUrl}${this.controller}/gridExportCSV`;
  private urlGetReturnListExportExcel = `${environment.apiUrl}${this.controller}/gridExportExcel`;
  private urlGetSingleRecordReturnList = `${environment.apiUrl}${this.controller}/gridSingleRecord`;
  private urlGetDetail = `${environment.apiUrl}${this.controller}/returnRequestSendDetail`;
  private urlGetDetailFromTransaction = `${environment.apiUrl}${this.controller}/returnRequestSendTransactionDetail`;
  private urlGetReasonInitiateReturnList = `${environment.apiUrl}${this.controller}/returninitiatereasoncodelist`;
  private urlGetFraudClassifierList = `${environment.apiUrl}${this.controller}/fraudclassifierslist`;
  private urlPostInitiate = `${environment.apiUrl}${this.controller}/send`;

  constructor(private http: HttpClient) {
    super();
  }

  tableFilter(filter: ITableServerFilter): Promise<ITableServerResponseFilter | undefined> {
    return firstValueFrom(
      this.http.post<ITableServerResponseFilter>(this.urlGetReturnList, filter)
    );
  }

  tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    return firstValueFrom(
      this.http.post(this.urlGetReturnListExportCSV, filter, { responseType: 'blob' })
    );
  }

  tableExportExcel(filter: ITableServerFilter): Promise<any | undefined> {
    return firstValueFrom(this.http.post(this.urlGetReturnListExportExcel, filter));
  }

  tableFilterSingleRecordById(
    rtpUniqueMessageId: string
  ): Promise<IRtpInitiatedReturnList | undefined> {
    return firstValueFrom(
      this.http.get<IRtpInitiatedReturnList>(
        `${this.urlGetSingleRecordReturnList}/${rtpUniqueMessageId}`
      )
    );
  }

  getDetail(rtpUniqueMessageId: string): Promise<IRtpInitiatedReturnDetails | undefined> {
    return firstValueFrom(
      this.http.get<IRtpInitiatedReturnDetails>(`${this.urlGetDetail}/${rtpUniqueMessageId}`)
    );
  }

  getDetailFromTransaction(
    rtpUniqueMessageId: string
  ): Promise<IRtpInitiatedReturnDetails | undefined> {
    return firstValueFrom(
      this.http.get<IRtpInitiatedReturnDetails>(
        `${this.urlGetDetailFromTransaction}/${rtpUniqueMessageId}`
      )
    );
  }

  initiate(initiateReturn: IReturnInitiate): Promise<IWebMessage | undefined> {
    return firstValueFrom(this.http.post<IWebMessage>(this.urlPostInitiate, initiateReturn));
  }

  reasonInitiateReturnList(_rtpUniqueMessageId: string): Promise<any> {
    return firstValueFrom(this.http.get<any>(this.urlGetReasonInitiateReturnList));
  }

  fraudClassifierList(): Promise<any> {
    return firstValueFrom(this.http.get<any>(this.urlGetFraudClassifierList));
  }
}
